module.exports = __webpack_public_path__ + "./images/p16.JPG?7cbb14bcf385f04d591ee614e5d113e8";


//////////////////
// WEBPACK FOOTER
// ./src/products/p16.JPG
// module id = 51
// module chunks = 0